import { useState } from 'react';

const FAQS = [
  {
    q: '吃瓜网站线路一是什么？',
    a: '吃瓜网站线路一是51吃瓜官网全网最新入口，聚合全网热门吃瓜内容，覆盖娱乐圈、网红圈、商业圈等多领域，每日更新最新爆料和深度解读，是您一站式吃瓜的首选平台。',
  },
  {
    q: '如何找到51吃瓜网址的最新入口？',
    a: '直接收藏本页面即可随时访问51吃瓜网址的最新入口。我们作为吃瓜网站首页，会持续更新和维护51吃瓜线路一入口，确保您始终能通过本页面直达51吃瓜网。',
  },
  {
    q: '吃瓜网站的内容更新频率是怎样的？',
    a: '我们的编辑团队全天候监控全网热点，吃瓜网站线路一每天滚动更新海量内容。重大突发事件最快可在几分钟内上线，确保您看到的51吃瓜官网全网最新信息。',
  },
  {
    q: '浏览51吃瓜网是否安全？会泄露隐私吗？',
    a: '绝对安全。吃瓜网站线路一采用匿名浏览机制，不追踪用户行为，不记录浏览历史，不需要注册登录。您可以放心在51吃瓜入口浏览所有内容，隐私得到充分保护。',
  },
  {
    q: '如何向吃瓜网站投稿或提供线索？',
    a: '欢迎通过页面底部的联系方式向我们投稿或提供爆料线索。您可以通过Telegram或微信联系我们，吃瓜网站线路一承诺严格保护爆料人信息。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于51吃瓜网站和吃瓜网站线路一的常见疑问解答
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {FAQS.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-4 text-left cursor-pointer hover:bg-background-50 transition-colors"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading flex-1">
                  {item.q}
                </h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-${
                      openIndex === i ? 'subtract-line' : 'add-line'
                    } text-lg text-foreground-500 transition-transform`}
                  ></i>
                </span>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}